import { render, staticRenderFns } from "./Globalvalue.vue?vue&type=template&id=64e506ed&scoped=true&"
import script from "./Globalvalue.vue?vue&type=script&lang=js&"
export * from "./Globalvalue.vue?vue&type=script&lang=js&"
import style0 from "./Globalvalue.vue?vue&type=style&index=0&id=64e506ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e506ed",
  null
  
)

export default component.exports